module.exports = __webpack_public_path__ + "media/images/lb/914-4196e3f72bb111bf0b8586c979002de0.svg";